import React, { useState } from "react";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";
import Pagination from "../../components/pageProps/shopPage/Pagination";
import ProductBanner from "../../components/pageProps/shopPage/ProductBanner";
import ShopSideNav from "../../components/pageProps/shopPage/ShopSideNav";
import { Helmet } from "react-helmet";

const Trade = () => {
  const [itemsPerPage, setItemsPerPage] = useState(12);

  const itemsPerPageFromBanner = (itemsPerPage) => {
    setItemsPerPage(itemsPerPage);
  };

  return (
    <div className="max-w-container mx-auto px-4">
      <Helmet>
        <meta charSet="utf-8" />
        <title>International Trade Products - RK Global Trader</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        />
        <meta
          name="description"
          content="Discover high-quality export products for international trade at RK Global Trader. Explore our agriculture products, spices, and other commodities with verified global trade services."
        />
        <meta
          name="keywords"
          content="RK Global Trader, international trade, export products, global commerce, agriculture exports, spices export, export from India, import website, trading website, global trading products"
        />
        <meta
          name="author"
          content="RK Global Trader | Agriculture Product | Export from India"
        />
        <link rel="canonical" href="https://www.rkglobaltrader.com/trade" />
      </Helmet>

      <Breadcrumbs title="Products" />

      {/* ================= Products Section =================== */}
      <div className="w-full h-full flex pb-20 gap-10">
        {/* Sidebar for product categories and filters */}
        <div className="w-[20%] lgl:w-[25%] hidden mdl:inline-flex h-full">
          <ShopSideNav />
        </div>

        {/* Main products section */}
        <div className="w-full mdl:w-[80%] lgl:w-[75%] h-full flex flex-col gap-10">
          {/* Banner with featured products and filters */}
          <ProductBanner itemsPerPageFromBanner={itemsPerPageFromBanner} />

          {/* Paginated product listing */}
          <Pagination itemsPerPage={itemsPerPage} />
        </div>
      </div>
      {/* ================= End Products Section ===================== */}
    </div>
  );
};

export default Trade;
